import { API_URL } from '../../../constants/urls.constants';
import type { CommonResponse } from '../../../types';
import { authService } from '../../services/auth-service';
import { userLoggedOut, verifyUser } from './auth.slice';
import type { TGetOtpVerify } from './auth.types';

export const authApi = authService.injectEndpoints({
  endpoints: (builder) => ({
    sendOtp: builder.mutation({
      query: (body) => ({
        url: API_URL.sendOtp,
        method: 'POST',
        body,
      }),
    }),
    sendApplicantOtp: builder.mutation({
      query: (body) => ({
        url: API_URL.sendApplicantOtp,
        method: 'POST',
        body,
      }),
    }),
    verifyApplicantsOtp: builder.mutation<
      CommonResponse<TGetOtpVerify>,
      unknown
    >({
      query: (body) => ({
        url: API_URL.verifyApplicantsOtp,
        method: 'POST',
        body,
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          const res = data?.data;
          const userData = {
            access_token: res?.accessToken,
            user: res?.applicant,
          };

          // Store verified info, and access_token in localStorage
          localStorage.setItem('verifiedInfo', JSON.stringify(res?.applicant));
          localStorage.setItem('access_token', res?.accessToken);

          dispatch(verifyUser(userData));
        } catch (err) {
          dispatch(userLoggedOut());
          localStorage.removeItem('verifiedInfo');
          localStorage.removeItem('access_token');
        }
      },
    }),
    // TODO: OLD data
    uploadFile: builder.mutation({
      query: (data) => {
        return {
          url: API_URL.uploadFile,
          method: 'PATCH',
          body: data,
        };
      },
    }),
  }),
});

export const {
  useSendOtpMutation,
  useSendApplicantOtpMutation,
  useVerifyApplicantsOtpMutation,
  useUploadFileMutation,
} = authApi;
